// src/services/ratingService.js
import apiBaseUrl from '../../utils/config.js';

class RatingService {
  constructor() {
    this.baseUrl = `${apiBaseUrl}/ratings`;
  }

  getToken() {
    return localStorage.getItem("jwt");
  }

  getAuthHeaders() {
    const token = this.getToken();
    return {
      'Content-Type': 'application/json',
      ...(token && { Authorization: `Bearer ${token}` }),
    };
  }

  async request(endpoint, method, body = null) {
    const options = {
      method,
      headers: this.getAuthHeaders(),
    };

    if (body) {
      options.body = JSON.stringify(body);
    }

    const response = await fetch(`${this.baseUrl}${endpoint}`, options);

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`Request failed: ${errorText}`);
    }

    return await response.json();
  }

  // --- CRUD Methods ---

  // POST /api/ratings/add
  async addRating(ratingData) {
    return this.request("/add", "POST", ratingData);
  }

  // GET /api/ratings/all
  async getAllRatings() {
    return this.request("/all", "GET");
  }

  // GET /api/ratings/{id}
  async getRatingById(id) {
    return this.request(`/${id}`, "GET");
  }

  // GET /api/ratings/appointment/{appointmentId}
  async getRatingByAppointmentId(appointmentId) {
    return this.request(`/appointment/${appointmentId}`, "GET");
  }

  // GET /api/ratings/appointment/all/{appointmentId}
  async getAllByAppointmentId(appointmentId) {
    return this.request(`/appointment/all/${appointmentId}`, "GET");
  }

  // PUT /api/ratings/update/{id}
  async updateRatingById(id, ratingData) {
    return this.request(`/update/${id}`, "PUT", ratingData);
  }

  // PUT /api/ratings/update/appointment/{appointmentId}
  async updateRatingByAppointmentId(appointmentId, ratingData) {
    return this.request(`/update/appointment/${appointmentId}`, "PUT", ratingData);
  }
}

export default new RatingService();
